import DataDiaries from "../images/DataDiaries.png";
import TravelSphere from "../images/TravelSphere.jpg";
import SabLogo from "../images/SUSL.png";
import LogoNRB from "../images/NRB.png";

export const Bio = {
    name: "Madhushi Udeshika",
    roles: [
      "Web Developer",
      "Aspiring Business Analyst",
      "Tech Enthusiast"
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/MadhushiUdeshika",
    resume:
      "https://drive.google.com/file/d/15Pvw7cifn-hb0ufY8lx8IMjs-mT1v_sx/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/madhushi-udeshika",
    facebook: "https://www.facebook.com/madhushi.udeshika/",
    medium: "https://medium.com/@madhu-udeshika"
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Flutter",
          image:
            "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
        },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Node Js",
          image:
            "https://img.icons8.com/?size=100&id=54087&format=png&color=000000",
        }        
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Power BI",
          image:
            "https://img.icons8.com/?size=100&id=Ny0t2MYrJ70p&format=png&color=000000",
        },
        {
          name: "Microsoft Excel",
          image:
            "https://img.icons8.com/?size=100&id=BEMhRoRy403e&format=png&color=000000",},
        {
          name: "Git",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/2048px-Git_icon.svg.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Adobe XD",
          image:
            "https://cdn.freelogovectors.net/wp-content/uploads/2020/07/Adobe-xd-logo.png",
        },
        {
          name: "Figma",
          image:
            "https://zeroheight-wordpress-uploads.s3.amazonaws.com/wp-content/uploads/2022/11/small-icon_figma.png",
        },
      ],
    },
  ];
  

  export const projects = [
    {
      id: 0,
      title: "Smart Loan Website",
      description:
        "A responsive web application for a microfinance company. It provides users with an intuitive interface to explore loan options and more about the company.",
      src: "https://smartloan1.netlify.app/" ,
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRE1Yq__Iy0cXiTywR8BNop1gs2V6oXJCCEQkteow41LBb7w0b2WjPVbFAgFWOLOLY4YLM&usqp=CAU",
      tags: ["React", "HTML", "CSS", "Javascript"],
      github: "https://github.com/MadhushiUdeshika/Employee-Management.git",
      live: "https://smartloan1.netlify.app/"
    },
    {
      id: 1,
      title: "Symptocare UI Design",
      description: "A Figma-based UI/UX design for an e-channeling platform that allows users to input their symptoms and receive doctor, hospital, and time schedule suggestions",
      image: "https://img.freepik.com/free-vector/online-doctor-concept_52683-37586.jpg?semt=ais_hybrid&w=740&q=80",
      tags: ["Figma"],
      figma: "https://embed.figma.com/proto/fBRAIQUgfFcAYY4gfNyFti/E-Channeling-Web?node-id=168-174&starting-point-node-id=133%3A98&embed-host=share"
    },
    {
      id: 2,
      title: "Image Classifier",
      description:
        "A model, trained to classify dog breeds based on a dataset of images using a convolutional neural network (CNN) with TensorFlow and Keras.",
      image:
        "https://assets-global.website-files.com/5fb24a974499e90dae242d98/634803a2ed2d57c2a50194e9_No%20code%20Image%20Classifier.png",
      tags: ["Python"],
      github: "https://github.com/MadhushiUdeshika/ImageClassifier.git"
    },
    
    {
      id: 3,
      title: "AI Chatbot",
      description:
        "Basic virtual therapist chatbot designed to engage in conversation and provide a supportive environment for users.",
      image:
        "https://blog.happyfox.com/wp-content/uploads/2021/10/enefits-of-Using-AI-Chatbots-for-Your-Business-and-Customers-01.png",
      tags: ["Python"],
      github: "https://github.com/MadhushiUdeshika/AI_Chatbot.git"
    }  
    
  ];
  
  export const blogs = [
    {
      id: 0,
      img: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*u_VncXP05SW3sF19",
      title: "Exploring AI",
      subtitle: "A thought-provoking series exploring the impact of AI on our future.",
      desc: "From virtual companions in healthcare and mental wellbeing to the role of AI in the metaverse, brain-inspired neuromorphic chips, and the importance of empathy in machines, this series dives into how artificial intelligence is reshaping human life and society.",
      link: "https://medium.com/@madhu-udeshika/list/exploring-ai-f681c0064417",
    },
    {
      id: 1,
      img: TravelSphere,
      title: "TravelSphere Sri Lanka",
      subtitle: "A tech-driven vision for transforming Sri Lanka’s tourism industry.",
      desc: "This series showcases the design and architecture of a modern tourism and hospitality platform. It highlights the use of microservices, technology stacks, and the broader vision behind building a smarter, more connected travel experience in Sri Lanka.",
      link: "https://medium.com/@madhu-udeshika/list/travelsphere-sri-lanka-c09ed87e4117",
    },
    {
      id: 2,
      img: DataDiaries,
      title: "The Data Diaries: Your Guide to Data Analysis",
      subtitle: "A beginner-friendly journey into the world of data analysis.",
      desc: "From understanding data types and cleaning techniques to exploratory analysis, statistics, and visualization, this series simplifies complex concepts into clear insights, helping readers learn how to turn raw data into meaningful stories and decisions.",
      link: "https://medium.com/@madhu-udeshika/list/the-data-diaries-your-guide-to-data-analysis-0f9c55ebd6f0",
    }
  ];

  export const education = [
    {
      id: 0,
      img: SabLogo,
      school: "Sabaragamuwa University of Sri Lanka",
      date: "2020 - 2025",
      degree: "BSc (Hons) in Computing & Information Systems",
      desc: "Completed a Bachelor’s degree in Computing & Information Systems, gaining a strong foundation in both software development and information systems management. Developed skills in programming, system analysis, software project management, agile development, database design, business intelligence, and enterprise resource planning.",
      modules: [
        "System Analysis & Design",
        "Agile Development",
        "Software Project Management",
        "Database Management Systems",
        "Business Intelligence",
        "Enterprise Resource Planning"
      ]
    }   
  ];

  export const careers = [
    {
      id: 0,
      img: LogoNRB,
      company: "New Release Biz Holdings (Private) Limited",
      role: "Trainee Developer",
      date: "Apr 2024 – Sep 2024",
      location: "Remote",
      desc: "Led a solo project from planning to execution, developing strong time management and organizational skills. Streamlined workflows by documenting clear procedures to improve team efficiency. Collaborated with cross-functional stakeholders to gather requirements and align project goals. Produced detailed proposals and Software Requirement Specifications (SRS), effectively communicating complex ideas. Designed user-friendly workflows and layouts using Figma, contributing to process improvements and efficient system design.",
      highlights: [
        "Project Coordination",
        "Process Optimization",
        "Cross-functional Collaboration",
        "Documentation & Reporting",
        "UI/UX Design (Figma)"
      ]
    }
  ];
  
  export const TimeLineData = [
    { year: 2024, text: "Started my journey" },
  ];